/*
 * @Descripttion: 封装数据请求
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-05-18 01:03:10
 */
import request from "./request";
import axios from "axios";
import store from "@/store";

const http = {
  /**
   * @descripttion: GET请求
   * @Author: juanjuanhui
   * @Date: 2021-06-23 21:10:32
   * @param {String} url 请求地址
   * @param {Object} params 请求参数
   * @return {*}
   */
  get(url, params) {
    const config = {
      method: "get",
      url,
    };
    if (params) config.params = params;
    return request(config);
  },
  /**
   * @description: POST请求
   * @Author: juanjuanhui
   * @Date: 2021-06-23 21:09:01
   * @param {String} url 请求地址
   * @param {Object} params 请求参数
   * @param contentType
   * @return {*}
   */
  post(url, params, contentType = undefined) {
    const config = {
      method: "post",
      url,
    };
    if (params) config.data = params;
    if (contentType) config.contentType = contentType;
    return request(config);
  },
  /**
   * @description: 通过blob 下载文件
   * @Author: quwandong
   * @Date: 2023-02-23 21:09:01
   * @param {*} url
   * @param {*} params
   * @returns
   */
  exportWithBlob(url, params) {
    return axios({
      method: "get",
      url,
      headers: {
        accessToken:
          store.state.accessToken ||
          localStorage.getItem("accessToken") ||
          "eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE2ODYxNzI0ODMsInVzZXJLZXkiOiI3NDcwNzQ3NjUwMzIxNjU0MjkwIn0.g8D6O9xdg4V3rLzNwmuHV5x0Y6I1dd-hucWiPW3V80KlExwvkMxFLr9FLpYdEZy4F0CoKPHNYKE87Vgl77ROuA",
      },
      params,
      responseType: "blob",
    });
  },
};
export default http;
